import values from 'mout/object/values'
import getSubtest from "./getSubtest";


export default function getThresholdData(userAssessment, studentScoring) {

  const SUBJECTS = ['English', 'Math', 'Reading', 'Science']
  let SUBTEST_IDS = {}
  SUBJECTS.forEach((subject) => {
    SUBTEST_IDS[subject] = getSubtest(subject, userAssessment).setId
  })
  const threshold = {
    composite: {},
    english: {},
    math: {},
    reading: {},
    science: {},
  }


  values(studentScoring).forEach(function tallyScaleScores(studentScore) {
    SUBJECTS.forEach(function tallySubtestCompleters(subject) {
      const subtestId = SUBTEST_IDS[subject]
      let scale
      if (studentScore.scoring.bySubtest[subtestId] && studentScore.scoring.bySubtest[subtestId].complete) {
        scale = studentScore.scoring.bySubtest[subtestId].scale
        if (threshold[subject.toLowerCase()][scale]) {
          threshold[subject.toLowerCase()][scale]++
        } else {
          threshold[subject.toLowerCase()][scale] = 1
        }
      }
    })
    if (studentScore.scoring.byTest.complete) {
      //tally composite scores of test completers
      const composite = studentScore.scoring.byTest.scale
      if (threshold.composite[composite]) {
        threshold.composite[composite]++
      } else {
        threshold.composite[composite] = 1
      }
    }
  })

  return threshold
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/getThresholdData.js